<template>
    <v-popover :open.sync="opened" popoverInnerClass="add-condition-popover">
        <div class="plus-btn">
            <i class="fal fa-plus"></i>
        </div>
        <template v-slot:popover="{ isOpen }">
            <div class="condition-select-container">
                <label>
                    Condition
                </label>
                <multiselect
                    v-if="isOpen"
                    ref="condition-select"
                    :options="conditions"
                    track-by="uuid"
                    label="name"
                    autofocus
                    @select="onSelect">
                    <template v-slot:option="{option}">
                        <i v-if="option.name === 'New condition'">
                            <span class="pr-1">
                                <i class="fal fa-plus-circle"></i>
                            </span>
                            {{ option.name }}
                        </i>
                        <template v-else>
                            {{ option.name }}
                        </template>
                    </template>
                </multiselect>
            </div>
        </template>
    </v-popover>
</template>

<script>
export default {
    name: 'AutomationConditionAddBtn',
    props: {
        conditions: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            opened: false
        }
    },
    methods: {
        onSelect(condition) {
            this.$emit('add', condition)
            this.opened = false
        }
    }
}
</script>

<style scoped lang="scss">
.plus-btn {
    right: -40px;
}
</style>

<style lang="scss">
.add-condition-popover {
    min-width: 300px;
    padding: 8px !important;
}

.condition-select,
.condition-select-container {
    min-width: 300px;
}
</style>
